export default "__VITE_ASSET__k1$HJNsa__"